import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = {
    limit: Number
  }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length

    this.counterTarget.textContent = `${length} / ${this.limitValue}`
    this.counterTarget.classList.toggle("is-over-limit", length > this.limitValue)
  }
}
